var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.95,15.85h-4.48v13.48h4.48v-13.48ZM20,39.8C9.07,39.8.2,30.93.2,20S9.07.2,20,.2s19.8,8.86,19.8,19.8-8.86,19.8-19.8,19.8M12.71,14.01c1.56,0,2.54-1.04,2.54-2.33-.03-1.32-.97-2.33-2.51-2.33s-2.53,1.01-2.53,2.33.97,2.33,2.48,2.33h.03ZM31.11,29.33v-7.73c0-4.14-2.21-6.07-5.16-6.07-2.38,0-3.44,1.31-4.04,2.23v-1.91h-4.48c.06,1.26,0,13.48,0,13.48h4.48v-7.53c0-.4.03-.8.15-1.09.32-.81,1.06-1.64,2.3-1.64,1.62,0,2.27,1.24,2.27,3.05v7.21h4.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinNew);
export default __webpack_public_path__ + "static/media/linkedin_new.bd82a0e58f1ed79dd667d519df3ea724.svg";
export { ForwardRef as ReactComponent };